$(function() {
    const video = $('.js-video')

    function callBack() {
        const that = $(this)
        const btn = that.find('[data-video-btn]')
        const videoTag = that.find('[data-video-tag]')
        that.toggleClass('is-played')
        if (that.hasClass('is-played')) {
            videoTag.attr('src', videoTag[0].dataset.src)
            videoTag.attr('controls', 'controls')
            videoTag[0].play()
            btn.fadeOut()
        } 
    }

    video.on('click', '[data-video]', callBack)
    video.on('touchstart', '[data-video]', callBack)

    $('.js-video-slider').on('afterChange', (e, slick)=> {
        const currentSlide = $(slick.$slides[slick.currentSlide])
        const video = currentSlide.find('[data-video]')
        const videoTag = video.find('[data-video-tag]')
  
        if (video.hasClass('is-played')) {
            videoTag[0].pause()
        }
    })

    $('.js-video-slider').slick({
        slidesToShow: 1,
        arrows: false,
        asNavFor: '.js-video-thumbnail',
        vertical: false,
        autoplay: false,
        verticalSwiping: false,
        centerMode: false,
        useTransform: false,
    });

    $('.js-video-thumbnail').slick({
        // slidesToShow: 1,
        nav: false,
        vertical: true,
        focusOnSelect: true,
        verticalSwiping: true,
        autoplay: false,
        centerMode: true,      
        asNavFor: '.js-video-slider',    
        responsive: [
            {
                breakpoint: 1023,
                settings: {   
                    centerMode: false,
                    variableWidth: true,
                    vertical: false,
                    verticalSwiping: false,
                }
            }
        ]   
    });

})
